import React from 'react';

export default function Footer() {
  return (
    <footer>
      <div className="wrap footer-wrap">
        <p className="footer-copyright">
          Nagendra Vikram Dixit · Enterprise AI Agent Builder &amp; Senior Backend Engineer · {new Date().getFullYear()}
        </p>
        <p className="footer-subtext">
          Engineered with React 19 &amp; TypeScript 5 (Vite) · Bespoke Dark Aesthetic Design System
        </p>
      </div>
    </footer>
  );
}
